/* store para los limites de un usuario especifico */
import { create } from "zustand";
import { api } from "../services/api";

const usePlanesStore = create((set, get) => ({
  limites: null,
  loading: false,
  error: null,
  lastFetch: null,
  TTL: 10 * 60 * 1000,

  setLimites: (limites) =>
    set({
      limites,
      lastFetch: Date.now(),
      error: null,
    }),

  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  fetchLimites: async (force = false) => {
    const state = get();
    const ahora = Date.now();

    if (!force && state.lastFetch && ahora - state.lastFetch < state.TTL) {
      return state.limites;
    }
    set({ loading: true, error: null });

    try {
      const response = await api.limites.getAllLimites();

      if (response.status === "success") {
        set({
          limites: response.data,
          lastFetch: Date.now(),
          loading: false,
          error: null,
        });

        return response.data;
      } else {
        console.error("[PLANES] Error en respuesta:", response.message);
        set({
          loading: false,
          error: response.message || "Error al obtener límites",
        });
        return null;
      }
    } catch (error) {
      console.error("[PLANES] Error de conexión:", error);
      set({
        loading: false,
        error: error.message || "Error de conexión",
      });
      return null;
    }
  },

  fetchLimitesParaAccion: async () => {
    return get().fetchLimites(true);
  },

  puedeCrearEvento: () => {
    const { limites } = get();
    if (!limites) return true;
    if (limites.cantidad_eventos === "ilimitado") return true;

    const puede = limites.eventos_disponibles > 0;
    return puede;
  },

  getLimitesEventos: () => {
    const { limites } = get();
    if (!limites) return null;

    return {
      limite: limites.limite_eventos,
      actuales: limites.eventos_actuales,
      disponibles: limites.eventos_disponibles,
      esIlimitado: limites.cantidad_eventos === "ilimitado",
    };
  },

  refrescarLimites: async () => {
    set({ lastFetch: null });
    return get().fetchLimites(true);
  },

  reset: () => {
    set({
      limites: null,
      loading: false,
      error: null,
      lastFetch: null,
    });
  },
}));

export default usePlanesStore;
